import {
  ICampaignDetail,
  ICampaignExpenseRow,
  ICampaignListRow,
  ICampaignMemberRow,
  ICampaignMembershipRule,
  ICampaignReferralRow,
} from '@common/interfaces/campaign'
import { ICrmListResponse } from '@common/interfaces/crm'
import { combineReducers } from 'redux'
import { loadingArrayReducer } from '../../helpers/helpers'
import { createLoadingDataReducer } from '../../helpers/redux'
import * as actions from './actions'

// Writes are saving types: the page refetches what they touch rather than patching rows in place.
export default combineReducers({
  loadingArray: loadingArrayReducer(
    [actions.prefix],
    [actions.LIST_CAMPAIGNS_REQUEST, actions.SHOW_CAMPAIGN_REQUEST],
  ),
  campaigns: createLoadingDataReducer<ICrmListResponse<ICampaignListRow>>(
    [actions.LIST_CAMPAIGNS_REQUEST],
    [actions.CREATE_CAMPAIGN_REQUEST],
  ),
  campaign: createLoadingDataReducer<ICampaignDetail>(
    [actions.SHOW_CAMPAIGN_REQUEST],
    [actions.UPDATE_CAMPAIGN_REQUEST],
  ),
  members: createLoadingDataReducer<ICrmListResponse<ICampaignMemberRow>>(
    [actions.LIST_MEMBERS_REQUEST],
    [
      actions.ADD_MEMBERS_REQUEST,
      actions.UPDATE_MEMBER_REQUEST,
      actions.UPDATE_MEMBERS_STATUS_REQUEST,
      actions.REMOVE_MEMBER_REQUEST,
    ],
  ),
  referrals: createLoadingDataReducer<ICampaignReferralRow[]>([actions.LIST_REFERRALS_REQUEST]),
  expenses: createLoadingDataReducer<{ data: ICampaignExpenseRow[]; total: number }>([
    actions.LIST_EXPENSES_REQUEST,
  ]),
  rules: createLoadingDataReducer<ICampaignMembershipRule[]>(
    [actions.LIST_RULES_REQUEST],
    [actions.SAVE_RULE_REQUEST, actions.DELETE_RULE_REQUEST],
  ),
})
